import { render, staticRenderFns } from "./OverviewGraphicBarDots.vue?vue&type=template&id=4515d98a&scoped=true"
import script from "./OverviewGraphicBarDots.vue?vue&type=script&lang=js"
export * from "./OverviewGraphicBarDots.vue?vue&type=script&lang=js"
import style0 from "./OverviewGraphicBarDots.vue?vue&type=style&index=0&id=4515d98a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515d98a",
  null
  
)

export default component.exports